import * as React from 'react';
import 'dayjs/locale/de';
import styles from '../css/SmallConfigTemp.module.css'
import {styled} from '@mui/system';
import axios from "axios";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
import '../styles.css'
import '../css/Configuration.css';
import Button from "@mui/material/Button";
import { useGrowSetup } from '../GrowSetupContext';




export default function SmallConfigCo2(props) {
    const { grow_setup, setGrowSetup } = useGrowSetup();
    const [data, setData] = useState({
        sun_rise: dayjs('2022-04-17T15:30').format("HH:mm"),
        sun_rise_dayjs: dayjs('2022-04-17T15:30'),
        sun_set: dayjs('2022-04-17T15:30').format("HH:mm"),
        sun_set_dayjs: dayjs('2022-04-17T15:30'),
        sun_set_end: dayjs('2022-04-17T15:30').format("HH:mm"),
        sun_rise_end: dayjs('2022-04-17T15:30').format("HH:mm"),
        temperatur_tag: 22,
        temperatur_nacht: 20,
        luftfeuchte_tag: 55,
        luftfeuchte_nacht: 60,
        abluft_max_intensity: 50,
        abweichung_luftfeuchte: 5,
        dauer: 30,
        calibration_co2: 0,

    });




    const fetchData = async (measure, token) => {
        if (grow_setup > 0) {
            try {
                axios.post('/get_sys_config_grow_setup/' + grow_setup, {}, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + token,
                        'Method': 'GET',
                    },
                }).then(response => {
                    setData(response.data);
                    response.data.has_changed_klima = 'yes'
                    response.data.has_changed_hydro = 'yes'
                    response.data.sun_rise_dayjs = dayjs("01/01/2024 " + response.data.sun_rise)
                    response.data.sun_set_dayjs = dayjs("01/01/2024 " + response.data.sun_set)
                    setData(response.data);
                });


            } catch (error) {
                console.error(error);
            }
        }
    };

    useEffect(() => {
        fetchData();

    }, [grow_setup]);

    function setCalibration(v){
        data.calibration_co2 = 1;
        setData({...data});
        save_config();
    }

    function save_config() {
        try {
            axios.post('/config_save/' + grow_setup + '&0', {data: data}, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + props.token,
                    'Method': 'GET',
                },
            }).then(result => {
                console.log('Save Success:');

                //this.state.layout = this.generateLayout(result);
            })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });

        } catch (error) {
            console.error(error);
        }


    }

    return (
        <div className={styles.cardTemperatur}>
            <div className={styles.frameGroupTemperatur}>
                <div className={styles.headline}>
                    <b className={styles.temperatur}>Temperatur</b>
                </div>


            </div>
            <div className={styles.config}>
                <div className={styles.frameParentTemperatur}>
                    <div className={styles.frameGroupTemperatur}>
                        <div className={styles.frameContainer}>
                            <div className={styles.temperaturTagParent}>
                                <div className={styles.temperaturTag}>Kalibrieren</div>
                                <div>ACHTUNG! Der Sensor sollte mindestens 20 Minuten an frischluft sein vor der Kalibrierung</div>
                                <Button variant={"contained"}  size="medium" onClick={setCalibration}
                                >
                                    Kalibrieren
                                </Button>
                            </div>

                        </div>
                    </div>
                </div>


            </div>

        </div>

)
    ;
}


const blue = {
    100: '#daecff',
    200: '#b6daff',
    300: '#66b2ff',
    400: '#3399ff',
    500: '#007fff',
    600: '#0072e5',
    700: '#0059B2',
    800: '#004c99',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const StyledInputRoot = styled('div')(
    ({theme}) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`,
);

const StyledInput = styled('input')(
    ({theme}) => `
  font-size: 0.875rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.375;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 4px ${
        theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
    };
  border-radius: 8px;
  margin: 0 8px;
  padding: 10px 12px;
  outline: 0;
  min-width: 0;
  width: 4rem;
  text-align: center;

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]};
  }

  &:focus-visible {
    outline: 0;
  }
`,
);

const StyledButton = styled('button')(
    ({theme}) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 999px;
  border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
  color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
  width: 32px;
  height: 32px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &:hover {
    cursor: pointer;
    background: ${theme.palette.mode === 'dark' ? blue[700] : blue[500]};
    border-color: ${theme.palette.mode === 'dark' ? blue[500] : blue[400]};
    color: ${grey[50]};
  }

  &:focus-visible {
    outline: 0;
  }

  &.increment {
    order: 1;
  }
`,
);